import { all, call, fork, put, takeEvery } from 'redux-saga/effects';
import * as ReportingRead from '../../Apis/ReportingReadApi';
import * as Actions from './VirtualEventsActions';
import { forceLoginIfExpired } from '../Utils/RedirectionUtils';

export function* getVirtualEventsWatcher() {
  yield takeEvery(Actions.GET_VIRTUAL_EVENTS_REQUEST, getVirtualEventsWorker);
}

export function* getVirtualEventsWorker(action) {
  try {
    let virtualEventsList = [];
    const { fromTime, toTime } = action.payload;
    const axiosResponse = yield call(ReportingRead.getVirtualEvents, fromTime, toTime);
    yield put({ type: Actions.RESET_FILTER_SELECTED_VIRTUAL_EVENT_KEY });
    const events = axiosResponse.data.events;
    virtualEventsList = [...virtualEventsList, ...events];
    yield put({
      type: Actions.GET_VIRTUAL_EVENTS_SUCCESS,
      payload: { virtualEventsList }
    });
  } catch (error) {
    yield put({ type: Actions.GET_VIRTUAL_EVENTS_FAILURE, error });
    forceLoginIfExpired(error);
  }
}

export default function* rootSaga() {
  yield all([fork(getVirtualEventsWatcher)]);
}



// WEBPACK FOOTER //
// ./src/Reducks/VirtualEvents/VirtualEventsSagas.js